
<div id="chartmap" [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background-color': '#ffffff'}"></div>
